import { motion } from 'framer-motion'
import { ReactNode } from 'react'

interface MotionTextProps {
  children: ReactNode
  delay?: number
  className?: string
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'p' | 'span'
}

export const MotionText = ({
  children,
  delay = 0,
  className = '',
  as = 'p'
}: MotionTextProps) => {
  const textVariants = {
    initial: { 
      opacity: 0, 
      y: 20 
    },
    animate: { 
      opacity: 1, 
      y: 0,
      transition: {
        duration: 0.2,
        ease: "easeOut",
        delay
      }
    },
    exit: {
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.2,
        ease: "easeOut"
      }
    }
  }

  const Component = motion[as]

  return (
    <Component
      variants={textVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      className={className}
    >
      {children}
    </Component>
  )
}

export default MotionText